const AbstractAuthenticationView = require("./AbstractAuthenticationView");
const Utils = require("../common/Utils");
const postal = require("../common/PubSub");

function LogonView(isTouch) {
    AbstractAuthenticationView.call(this);
    const self = this;

    const $content = $(require("html!./logon_view_content.html"));
    this.setInnerContent($content);
    const $authSchemeSelector = $content.find("#authSchemeSelector");
    const $authFieldsContainer = $content.find("#authFields");
    const $usernameInput = $content.find("#uname");
    const $radiusChallengeResponseContainer = $content.find(".radiusChallengeResponse");
    const $loginAsDiffUser = $content.find(".radiusLoginAsDiffUser");
    const $loginButton = $content.find("#footerBtnLogin");

    let currentAuthSchemes;
    let current = [];

    $authSchemeSelector.on("change", function() {
        $authFieldsContainer.empty();
        let optionSelected = $authSchemeSelector.find("option:selected");
        let index = parseInt(optionSelected.val());
        let text = optionSelected.text();
        current = toList(text);
        buildAuthFieldsForScheme(currentAuthSchemes[index]);
    });

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "Logon";
    };

    const $form = $content.find("form");

    // Allow submitting of the login form by pressing Enter (or a mobile phone equivalent)
    $form.find("input").each(function() {
        Utils.registerKeyboardSubmit($(this), submitLoginForm);
    });

    $content.find("#logonCancel").on("click", function() {
        self.publishEvent("LogonController", "cancel");
    });

    $form.find(".radiusLoginAsDiffUser").on("click", function() {
        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
            self.publishEvent("LogonController", "login-as-diff-user");
        } else {
            self.publishEvent("RADIUSController", "login-as-diff-user");
        }
    });

    $loginButton.on("click", submitLoginForm);

    $(document).on("appmodulesloaded", function() {
        if (isTouch) {
            self.getContent().on("swiperight", function() {
                self.publishEvent("NavigationManager", "go-back");
            });
        }
    });

    let passwdLabel = "common::login.password";
    this.setPasswdLabel = function(passwordLabel) {
        passwdLabel = passwordLabel;
    };

    this.setUsername = function(username) {
        $usernameInput.val(username);
    };

    this.setDemoCreds = function(username, password) {
        this.setUsername(username);
        $authFieldsContainer.find("input").val(password);
    };

    this.showError = function(title, message) {
        // Remove focus from the username field (BNVS-4961 - On Nexus 7 tablet invalid logons duplicate the text on
        // username field)
        $content.find("#uname").trigger("blur");
        self.getContent().find(".pageTitle").text(title).show();
        self.getContent().find(".pageMessage").text(message);
    };

    this.setWelcomeMessage = function(message) {
        let $motdMessage = $content.find("#motdMessage");

        if (message && message.length > 0) {
            $motdMessage.empty();
            $motdMessage.append(Utils.makeBreakText(message));
            $motdMessage.show();
        } else {
            $motdMessage.hide();
        }
    };


    const channel = postal.channel("LogonController");
    function clearActivePolicy() {
        current = [];
    }

    channel.subscribe("show-error", clearActivePolicy);
    channel.subscribe("access-denied", clearActivePolicy);
    $(document).on("userauthenticated", clearActivePolicy);

    function toList(text) {
        return text.split(/(?: \+ |, )/);
    }

    function isSubset(a, b) {
        return a.every(function(elem) {
            return b.indexOf(elem) >= 0;
        });
    }

    function findCurrent() {
        let index = 0;
        let currentIndex = 0;

        $authSchemeSelector.find("option").each(function() {
            let text = this.text;
            let list = toList(text);

            if (isSubset(list, current)) {
                current = list;
                currentIndex = index;
            }
            index += 1;
        });
        return currentIndex;
    }

    this.configureAuthFields = function(usernameKey, authOptions) {
        this.reset();

        $usernameInput.closest(".ui-input-text").toggle(usernameKey !== undefined);
        $usernameInput.attr("name", usernameKey);

        if (!authOptions) {
            $authSchemeSelector.closest(".ui-select").hide();
            return;
        }

        currentAuthSchemes = authOptions.schemes;
        $authSchemeSelector.closest(".ui-select").toggle(currentAuthSchemes && currentAuthSchemes.length > 1);

        if (!$.isEmptyObject(authOptions.challenge)) {
            $authSchemeSelector.closest(".ui-select").hide();
            let scheme = {};
            scheme[authOptions.challenge.scheme] = {};
            buildAuthFieldsForScheme(scheme);
            let challengeMsg = "common::" + authOptions.challenge.message;

            if (challengeMsg === "common::radius.resp.acceptPin") {
                let $field = $authFieldsContainer.find("input[name='" + authOptions.challenge.scheme + "']");
                $field.val("yes");
                $field.parent().hide();
            }
            $radiusChallengeResponseContainer.text($.t(challengeMsg, {pin : authOptions.challenge.info}));
            $radiusChallengeResponseContainer.show();
            $loginAsDiffUser.show();
            $loginButton.text($.t("common::login.saveContinue"));
        } else if (currentAuthSchemes) {
            if (currentAuthSchemes.length > 1) {
                // Populate dropdown with auth scheme options
                for (let i = 0; i < currentAuthSchemes.length; i++) {
                    let schemes = Object.keys(currentAuthSchemes[i]);
                    let label = Utils.getAuthSchemeDisplayLabel(schemes[0]);

                    for (let j = 1; j < schemes.length; j++) {
                        label += ((j === schemes.length - 1) ? " + " : ", ") + Utils.getAuthSchemeDisplayLabel(schemes[j]);
                    }

                    let $option = $("<option>", {text : label, value : i});

                    $authSchemeSelector.append($option);
                }
            }

            let currIndex = findCurrent();

            if (currentAuthSchemes[currIndex]) {
                $authSchemeSelector.prop("selectedIndex", currIndex);
                $authSchemeSelector.selectmenu("refresh");
                buildAuthFieldsForScheme(currentAuthSchemes[currIndex]);
            }
        }
    };

    function buildAuthFieldsForScheme(authScheme) {
        const schemeList = Object.keys(authScheme);

        // Display the non time sensitive ones first
        schemeList.forEach(function(scheme) {
            if (!authScheme[scheme].isTimeSensitive) {
                let $input = $("<input>", {placeholder : Utils.getAuthSchemeDisplayLabel(scheme), name : scheme, type : "password"});
                $authFieldsContainer.append($input);
            }
        });

        // Then the time sensitive ones
        schemeList.forEach(function(scheme) {
            if (authScheme[scheme].isTimeSensitive) {
                let $input = $("<input>", {placeholder : Utils.getAuthSchemeDisplayLabel(scheme), name : scheme, type : "password"});
                $input.addClass("timeSensitive");
                $input.on("keyup", function() {
                    toggleTimeSensitiveAuths(scheme, !$input.val());
                });
                $input.on("paste", function() {
                    setTimeout(function() {
                        toggleTimeSensitiveAuths(scheme, !$input.val());
                    }, 0); // Timeout of 0ms puts the event on bottom of stack to give chance for input to be pasted from clipboard
                });
                $authFieldsContainer.append($input);
            }
        });

        $authFieldsContainer.enhanceWithin();
    }

    function toggleTimeSensitiveAuths(scheme, enabled) {
        // Find all time sensitive inputs and set enabled/disabled, unless input name matches the current scheme
        $authFieldsContainer.find("input.timeSensitive").each(function() {
            if ($(this).attr("name") !== scheme) {
                Utils.setElementEnabled($(this), enabled);
            }
        });
    }

    this.reset = function() {
        currentAuthSchemes = [];

        // Show the logon form
        $form.show();

        // Hide the cancel button
        $content.find("#logonCancel").hide();
        $radiusChallengeResponseContainer.hide();
        $loginAsDiffUser.hide();

        // Show the 'Login' button
        $loginButton.text($.t("common::login.login"));
        $loginButton.show();

        // Remove username / auth fields
        $authSchemeSelector.empty();
        $authFieldsContainer.empty();
        $usernameInput.val("");

        // Reset the page title and page message
        self.getContent().find(".pageTitle").text($.t("common::login.title"));
        self.getContent().find(".pageMessage").text("");
    };

    function submitLoginForm() {
        // Prepare data for the request
        let formParams = $form.serializeObject();

        self.reset();

        // Hide the logon form, and show a cancel button and loading spinner
        $form.hide();
        $("#logonCancel").show();

        self.publishRequest("LogonController", "logon-user", formParams);
    }
}

Utils.inherits(LogonView, AbstractAuthenticationView);

module.exports = LogonView;